// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-card[data-v-47e8a6bb]{display:flex;flex-direction:column;margin-bottom:24px}.router-link[data-v-47e8a6bb]{font-size:17px;line-height:23px;color:#158ad2;margin-bottom:17px;opacity:1;text-decoration:none;display:inline-block}.mt-20[data-v-47e8a6bb]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
